import { render, staticRenderFns } from "./DoughnutChartOverviewSection.vue?vue&type=template&id=46c13e6e"
import script from "./DoughnutChartOverviewSection.vue?vue&type=script&lang=js"
export * from "./DoughnutChartOverviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports